// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OjQ9A7lrk0Kc0Sxw{padding:6px 8px;border-radius:4px;border:1px solid var(--py-neutral-4);border-top:1px solid silver;outline:none;width:100%;box-sizing:border-box;height:100%;min-width:0px;background-color:rgba(0,0,0,0);font-size:14px;line-height:1.2;color:var(--py-neutral-8);resize:none}.OjQ9A7lrk0Kc0Sxw::placeholder{color:var(--py-neutral-4)}.OjQ9A7lrk0Kc0Sxw:disabled{background-color:var(--py-neutral-0);color:var(--py-neutral-4);border:1px solid var(--py-neutral-2);cursor:not-allowed}.OjQ9A7lrk0Kc0Sxw.E0Idju5trSYLmoiF{border:1px solid var(--py-red-6)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `OjQ9A7lrk0Kc0Sxw`,
	"error": `E0Idju5trSYLmoiF`
};
export default ___CSS_LOADER_EXPORT___;
